import React, { useEffect, useState, useRef } from 'react';
import AddBraintreeCard from '../../components/PaymentMethod/AddBraintreeCard';
import { makeStyles } from '@material-ui/styles';
import { compose } from '../../utils/compose';
import { connect } from 'react-redux';
import { navigationActions } from '../../store/actions/navigation/navigation';
import { httpClient, paymentMethodsBaseUrl } from "../../http-client/http-client";
import { billingInfoActions } from "../../store/actions/billingInformation/billingInformation";
import FullpageSpinner from "../../components/UI/FullpageSpinner/FullpageSpinner";
import { Button, CircularProgress, FormHelperText, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

const useStyles = makeStyles(theme => ({
  mainContent: {
    flex: 1,
    padding: theme.spacing(2),
    maxWidth: '900px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: "center",
    margin: "auto"
  },
  warning: {
    marginTop: theme.spacing(2),
    backgroundColor: '#d9d9d97d'
  }
}));

const AddPaymentMethod = (props) => {
  const { onSetTitle, history, billingInformation, onFetchBillingInfo, accessToken } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [ready, setReady] = useState(false);
  const ref = useRef();
  const [token, setToken] = useState('');
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(`${new Date().getTime()}`);

  useEffect(() => {
    onSetTitle('addPaymentMethod')
  }, [onSetTitle]);

  useEffect(() => {
    onFetchBillingInfo();
  }, [onFetchBillingInfo]);

  const getRecaptchaToken = React.useCallback((token) => {
    setToken(token);
  }, []);

  const onSubmit = async () => {
    setRefreshReCaptcha(`${new Date().getTime()}`);
    setSubmitting(true);

    try {
      const payload = await ref.current.getPayload();


      try {
        const addResult = await httpClient.post(`${paymentMethodsBaseUrl}/addcard`, accessToken, {
          Payload: payload,
          reCAPTCHAToken: token
        });

        console.log('success');
        setTimeout(() => {
          history.push('/');
        }, 0);
      }
      catch (error) {
        console.log('add error', error);
        setSubmitting(false);
        setError(error.error.HumanError);
      }

    } catch (error) {
      setSubmitting(false);
      setError(error.Message);
    }

  }

  const onReady = (ready, error) => {
    setReady(ready);
    setError(error);
  }

  if (billingInformation.fetching) {
    return <FullpageSpinner />
  } else {
    return (
      <div className={classes.mainContent}>
        <AddBraintreeCard innerRef={ref} onReady={(ready, error) => onReady(ready, error)} />
        {ready && (
          <>
            <Grid container direction="row" alignItems="center" justify="flex-end" spacing={2}>
              {error && (
                <Grid item>
                  <FormHelperText className="Mui-error">{error}</FormHelperText>
                </Grid>
              )}

              <Grid item>
                <Button variant="contained" color="primary" onClick={onSubmit} disabled={submitting}>
                  {submitting ? <CircularProgress size={20} color="inherit" style={{ marginRight: "14px" }} /> : null}
                  {t('add')}
                </Button>
              </Grid>
            </Grid>
            <Grid container direction="row" alignItems="center" spacing={1} className={classes.warning}>
              <Grid item>
                <FontAwesomeIcon icon="info-circle" />
              </Grid>
              <Grid item xs={true}>
                {t('card3DsRedirectWarning')}
              </Grid>
            </Grid>
            <GoogleReCaptcha action="submit" onVerify={getRecaptchaToken} refreshReCaptcha={refreshReCaptcha} />
          </>
        )}
      </div>
    );
  }
};

const mapStateToProps = state => ({
  accessToken: state.oidc.user.access_token,
  billingInformation: state.billingInformation
});

const mapDispatchToProps = dispatch => ({
  onSetTitle: title => dispatch(navigationActions.setTitle(title)),
  onFetchBillingInfo: () => dispatch(billingInfoActions.fetch())
});

const composed = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AddPaymentMethod);

export default composed;